import React from 'react';
import { SectionHeadingProps } from '../types';
function SectionHeading(props: SectionHeadingProps) {
  return <h3 className="abt-heading">{props.Heading}</h3>;
}
export default SectionHeading;
